import { isEmpty, get } from 'lodash'

export const handleLoading = (context, loading) => {
    if (!get(context.data.loadings, loading, false)) {
    	context.data.loadings[loading] = true

        return
    }

	context.data.loadings[loading] = undefined
}

export const handleErrors = (context, replace, remove) => {
    if (isEmpty(replace) && !isEmpty(remove)) {
		remove.forEach(removeItem => context.data.errors[removeItem] = null)
    }

    context.data.errors = isEmpty(replace) ? {} : replace
}
